<template>
    <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
        <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <div class="tab-content">
                <div>
                    <div class="panel-body">
                        <div class="ibox-content">

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Start Date<span style="color:red">*</span></label>
                                <div class="col-sm-5">
                                    <el-form-item prop="begDate" :rules="{
            required: true,
            message: $t('message.required'),
            trigger: 'change'
        }">
                                        <el-date-picker v-model="detailInfo.begDate" type="date"
                                            value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label"> End Date <span style="color:red">*</span></label>
                                <div class="col-sm-5">
                                    <el-form-item prop="endDate" :rules="{
            required: true,
            message: $t('message.required'),
            trigger: 'change'
        }">
                                        <el-date-picker v-model="detailInfo.endDate" type="date"
                                            value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="hr-line-dashed"></div>
                            <div class="form-group">
                                <div class="col-sm-12">
                                    <div class="pull-right">
                                        <el-button type="primary" @click="checkEvent()">
                                            Export
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import eventBus from "../eventbus";
import config from "../config";
import axios from "axios"
export default {
    mixins: [config.globalMixin],
    data() {
        return {
            detailInfo: {
                begDate: "",
                endDate: "",
            },

        };
    },
    created() {


    },
    methods: {
        checkEvent() {
            this.$refs["detailInfo"].validate(valid => {
                if (valid) {
                    this.submit();
                } else {
                    return false;
                }
            });
        },
        async handleExportStoreInventory() {


        },
        async submit() {

            var start = new Date(this.detailInfo.begDate).getTime();
            var end = new Date(this.detailInfo.endDate).getTime()
            if (this.$dayjs(end).diff(this.$dayjs(start), 'day') < 0) {
                this.$message({
                    message: 'The end date cannot be earlier than the start date.',
                    type: 'warning'
                });
                return;
            }
            var that = this;
            var objdata = this.getAuthObj();
            objdata.begDate = this.detailInfo.begDate;
            objdata.endDate = this.detailInfo.endDate;
            let data = await axios.post(`${config.domain}` + this.apiConfig.memberCommentBoxExport, objdata, { 'responseType': 'blob' })
            if (data.data.status_code == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!(data && data.data)) return;
            const reader = new FileReader()
            reader.onload =  () => {
                try {
                    const json = JSON.parse(reader.result)
                    if (json.status_code == "000104") {
                        this.timeoutEvent();
                        return;
                    }
                    else {
                        this.$store.commit("setwarning", {
                            string: json.status_message,
                            boolean: true,
                            button: [{
                                name: "Cancel",
                                callBack: function () {
                                    that.$store.commit("setwarning", {
                                        string: "",
                                        boolean: false,
                                    });
                                }
                            }]
                        });
                    }
                } catch (e) {
                    const xlsFileName = 'FeedbackInfo' + this.$dayjs(objdata.begDate).format('YYYYMMDD') + ' - ' + this.$dayjs(objdata.endDate).format('YYYYMMDD') + '.xls'
                    const url = window.URL.createObjectURL(new Blob([data.data]), { type: "application/json" });
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", xlsFileName);
                    document.body.appendChild(link);
                    link.click();
                }
            }
            reader.readAsText(data.data)
        }
    },
    mounted() {
    }
};
</script>